import angular from 'angular';


class Throttle {
  constructor(delay, callback, $timeout) {
    this.delay = delay;
    this.callback = callback;
    this.$timeout = $timeout;
  }

  push(...args) {
    this.cancel();
    this.promise = this.$timeout(() => {
      delete this.promise;
      this.callback(...args);
    }, this.delay);
  }

  pull(...args) {
    this.cancel();
    this.callback(...args);
  }

  flush(...args) {
    if (this.promise) {
      this.pull(...args);
    }
  }

  cancel() {
    if (this.promise) {
      this.$timeout.cancel(this.promise);
      delete this.promise;
    }
  }
}

const throttleService = angular.module('ttb.services.throttle.service', [])
  .factory('throttleService', ['$timeout', ($timeout) => {
    const getThrottle = (delay, callback) => new Throttle(delay, callback, $timeout);

    return {
      getThrottle,
    };
  }])
  .name;

export default throttleService;



// WEBPACK FOOTER //
// ../services/throttle.service.js